export default "__VITE_ASSET__BI88hRlI__"